import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import service from './utils/request'
import ForceLogoutDialog from '@/components/ForceLogoutDialog.vue'

Vue.prototype.request = service
Vue.prototype.axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.component('ForceLogoutDialog', ForceLogoutDialog)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
